// Architect (Party A) persona API — work marketplace.
// axiosInstance's response interceptor returns response.data directly.
import axiosInstance from "../api/axios";

const BASE = "/architects";

export const signupArchitect = (data) => axiosInstance.post(`${BASE}/signup`, data);
export const getArchitectProfile = () => axiosInstance.get(`${BASE}/profile`);
export const updateArchitectProfile = (data) => axiosInstance.put(`${BASE}/profile`, data);
